import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import UpdateItemPriceContainer from 'app/containers/Marketing/PricingManagement/UpdateItemPrice'

const UpdateItemPricePageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.update_item_price)}</PageTitle>
      <UpdateItemPriceContainer />
    </>
  )
}
const UpdateItemPricePage = memo(UpdateItemPricePageCpn, isEqual)

export default UpdateItemPricePage
